import { z } from 'zod';
import { DisplaySettings } from '@/api/apis/route';

export const locationTrackingFormSchema = z.object({
  displayEstimatedTimeOfArrival: z.boolean(),
  displayLocationTracking: z.boolean(),
  deviceToDisplay: z.string().nonempty('Select a device'),
});

export type LocationTrackingFormValues = z.infer<typeof locationTrackingFormSchema>;

export const getLocationTrackingInitialValues = (data?: DisplaySettings) => {
  return {
    displayEstimatedTimeOfArrival: data?.displayEstimatedTimeOfArrival ?? false,
    displayLocationTracking: data?.displayLocationTracking ?? false,
    deviceToDisplay: data?.deviceToDisplay ?? '',
  };
};
